// extracted by mini-css-extract-plugin
module.exports = {"error":"access-denied_error__F4ZCY","content":"access-denied_content__1bzdW","warning":"access-denied_warning__3uz_o","text":"access-denied_text__1Ps_O"};